var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavDashboardIcon = function SvgNavDashboardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F2F4F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2M20 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2M20 28a1 1 0 1 0 0-2 1 1 0 0 0 0 2M27 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2M27 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2M27 28a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 28a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
export { SvgNavDashboardIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/NavDashboardIcon.83e8f2ce.svg";